import Vue from 'vue'
import App from './App.vue'
import router from './router'

import VueCookies from "vue-cookies";

// i18n
import { i18n } from './assets/js/i18n.js'

//Filtros
import VueCurrencyFilter from 'vue-currency-filter'

// Components
import Seccion from './components/Seccion.vue'
import BotonSeccion from './components/BotonSeccion.vue'
import ArticuloDetalle from './components/ArticuloDetalle.vue'
import Articulo from './components/Articulo.vue'
import Promociones from './components/Promociones.vue'
import Home from './components/Home.vue'
import CarroMini from "./components/CarroMini.vue";
import Checkout from "./components/Checkout.vue";
import store from './store/index';
// BUS
export var bus = new Vue()
Vue.config.devtools = true
Vue.config.productionTip = true
Vue.use(VueCurrencyFilter);
Vue.use(VueCookies);
// APP
new Vue({
	el: '#app',
	store,
	i18n,
	router,
	components: {
		Home,
		BotonSeccion,
		Seccion,
		ArticuloDetalle,
		Articulo,
		Promociones,
		CarroMini,
		Checkout
	},
	render: h => h(App),
}).$mount('#app')
